export enum GmailDnsRecordKind {
  SPF = "spf",
  DKIM = "dkim",
  DMARC = "dmarc",
}

//redontIgnore
export enum GmailDnsRecordStatus {
  OK = "ok",
  MISSING = "missing",
  MISCONFIGURED = "misconfigured",
  ERROR = "error",
  /** Google owns the mailbox domain, so the merchant has no DNS to publish. */
  NOT_APPLICABLE = "not_applicable",
}

/** Statuses the merchant can actually do something about. */
export function gmailDnsRecordNeedsAction(
  status: GmailDnsRecordStatus,
): boolean {
  return (
    status === GmailDnsRecordStatus.MISSING ||
    status === GmailDnsRecordStatus.MISCONFIGURED
  );
}
